import { Contact } from './Contact'
import { ServiceLocation } from './ServiceLocation'

export enum ServiceTeamFormFields {
	name = 'name',
	department = 'department',
	billingAgencyId = 'billingAgencyId',
	regionId = 'regionId',
	email = 'email'
}

export enum ServiceTeamMemberGenericFormFields {
	serviceTeamDepartmentId = 'serviceTeamDepartmentId',
	contactId = 'contactId',
	role = 'role'
}

export enum ServiceTeamSearchResultFields {
	searchResultByName = 'searchResultByName',
	searchResultByDepartmentId = 'searchResultByDepartmentId'
}

export enum SelectFilterFields {
	billingAgencyId = 'billingAgencyId',
	regionId = 'regionId'
}

export enum ServiceTeamRoleFormFields {
	aaManager = 'aaManager',
	aaTeamLead = 'aaTeamLead',
	accountAdministrator = 'accountAdministrator',
	billingSpecialistTeamLead = 'billingSpecialistTeamLead',
	billingSpecialist = 'billingSpecialist',
	director = 'director',
	opsManager = 'opsManager',
	programCoordinator = 'programCoordinator',
	programManager = 'programManager',
	srProgramManager = 'srProgramManager',
	scheduler = 'scheduler'
}

export interface ServiceTeamProgramManager {
	firstName: string
	lastName: string
	id: number
}

export declare namespace ServiceTeam {
	interface TeamMember {
		contactId: number
		role: BasicString
	}
	interface Basic extends Entity {
		teamDepartmentId: number
		department: string
		billingAgency: string
		region: string
		email: string | null
	}

	interface Detailed extends Omit<Basic, 'billingAgency' | 'region'> {
		billingAgency: Entity
		region: Entity
	}

	namespace Form {
		interface Generic {
			[ServiceTeamFormFields.name]: string
			[ServiceTeamFormFields.department]: string
			[ServiceTeamFormFields.billingAgencyId]: LabelValue<number> | null
			[ServiceTeamFormFields.regionId]: LabelValue<number> | null
			[ServiceTeamFormFields.email]: string
			[ServiceTeamRoleFormFields.aaManager]: LabelValue<number> | null
			[ServiceTeamRoleFormFields.aaTeamLead]: LabelValue<number> | null
			[ServiceTeamRoleFormFields.accountAdministrator]: LabelValue<number> | null
			[ServiceTeamRoleFormFields.billingSpecialistTeamLead]: LabelValue<number> | null
			[ServiceTeamRoleFormFields.billingSpecialist]: LabelValue<number> | null
			[ServiceTeamRoleFormFields.director]: LabelValue<number> | null
			[ServiceTeamRoleFormFields.opsManager]: LabelValue<number> | null
			[ServiceTeamRoleFormFields.programCoordinator]: LabelValue<number> | null
			[ServiceTeamRoleFormFields.programManager]: LabelValue<number> | null
			[ServiceTeamRoleFormFields.srProgramManager]: LabelValue<number> | null
			[ServiceTeamRoleFormFields.scheduler]: LabelValue<number> | null
		}
		interface Duplicate {
			[ServiceTeamFormFields.department]: string
			[ServiceTeamFormFields.billingAgencyId]: LabelValue<number> | null
		}
	}

	namespace Request {
		interface Add {
			[ServiceTeamFormFields.name]: string
			[ServiceTeamFormFields.department]: string
			[ServiceTeamFormFields.billingAgencyId]: number
			[ServiceTeamFormFields.regionId]: number
			[ServiceTeamFormFields.email]: string
			teamMembers: TeamMember[]
		}

		interface Edit extends Omit<Request.Add, ServiceTeamFormFields.billingAgencyId> {}

		interface Duplicate {
			[ServiceTeamFormFields.department]: string
			[ServiceTeamFormFields.billingAgencyId]: number
		}
	}

	namespace Search {
		interface Result {
			[ServiceTeamSearchResultFields.searchResultByName]: Entity[]
			[ServiceTeamSearchResultFields.searchResultByDepartmentId]: Entity[]
		}
	}

	namespace Member {
		interface Basic extends Id {
			serviceTeamName: string
			role: NameCode | null
			contact: Entity
		}

		namespace Form {
			interface Generic {
				[ServiceTeamMemberGenericFormFields.contactId]: LabelValue<number> | null
				[ServiceTeamMemberGenericFormFields.role]: LabelValue | null
			}

			interface Create extends Contact.Form.Create.Basic {
				role: LabelValue | null
			}
		}

		namespace Request {
			interface Add {
				[ServiceTeamMemberGenericFormFields.serviceTeamDepartmentId]: number
				[ServiceTeamMemberGenericFormFields.contactId]: number
				[ServiceTeamMemberGenericFormFields.role]: string
			}

			interface Edit {
				[ServiceTeamMemberGenericFormFields.contactId]: number
				[ServiceTeamMemberGenericFormFields.role]: string
			}

			interface Create extends Contact.Form.Create.Request {
				role: string
				serviceTeamDepartmentId: number
			}
		}
	}

	namespace ServiceSite {
		interface Basic extends ServiceLocation.Basic {}
	}
}
